import { Header } from "../../components/Header/header";
import { PerfilStyled } from "./styles";
import { Container } from "../../assets/styles/Container";
import { useContext, useEffect, useRef, useState } from "react";
import { ModalEdit } from "./components/Modals/Edit/ModalEdit";
import { ModalPosts } from "./components/Modals/Posts/ModalPosts";
import { api } from "../../api/api";
import { useParams } from "react-router-dom";
import { UserContext, iUserFollower } from "../../providers/UserContext";
import { Loading } from "../../components/LoadingProps/loading";
import { RoundButton } from "../../assets/styles/RoudeButton";
import { FaPenToSquare } from "react-icons/fa6";
import { PostContext } from "../../providers/PostContext";
import { ButtonStyled } from "../../components/Button/styles";
import { Follower } from "./components/Modals/Follow/Follower";
import { FaArrowDown } from "react-icons/fa";
import { Following } from "./components/Modals/Follow/Following";

export const Perfil = () => {
  const { getUserPosts, postsUser, setPostsUser } = useContext(PostContext);
  const { user, editPerfil } = useContext(UserContext);

  const [showFollowers, setShowFollowers] = useState(false),
    [showFollowing, setShowFollowing] = useState(false),
    [showPosts, setShowPosts] = useState(false),
    [postIdClicked, setPostIdClicked] = useState<number>(),
    [page, setPage] = useState(1),
    [hasMorePosts, setHasMorePosts] = useState(true);

  const [showEdit, setShowEdit] = useState(false);

  const [userPage, setUserPage] = useState<iUserFollower | null>(null);

  const [loading, setLoading] = useState(true),
    [loadingPost, setLoadingPost] = useState(false);

  const params = useParams();

  // Função para carregar os dados do dono do perfil
  useEffect(() => {
    const getPerfiluser = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/users/${params.username}`);
        setUserPage(response.data);
        setLoading(false);

        if (response.data) {
          setLoadingPost(true);
          setPostsUser(null); // Limpar o estado do usuário antes de buscar o novo usuário
          const postsResponse = await getUserPosts(response.data.id, page);
          if (postsResponse && postsResponse.count <= 20 * page) {
            setHasMorePosts(false);
          }
          setLoadingPost(false);
        }
      } catch (error) {
        console.log("Erro ao buscar usuário:", error);
        // setLoading(false);
      }
    };

    getPerfiluser();
  }, [params.username]);

  const loadMorePosts = async (id: number) => {
    try {
      setLoadingPost(true);

      // A CHAMADA DE NOVOS POSTS ESTÁ NO MODAL DE POSTS, POIS O STATE (PAGE)
      // ESTÁ COMPARTILHADO ENTRE OS DOIS ARQUIVOS. QUANDO O (PAGE) É INCREMANTADO
      // EM QUALQUER UM DOS ARQUIVOS, A BUSCA É FEITA PELO EFFECT DE MODAL POSTS

      setPage((prevPage) => prevPage + 1); // Incrementa o número da página
      setLoadingPost(false);
    } catch (error) {
      console.error("Erro ao carregar mais posts:", error);
      setLoadingPost(false);
    }
  };

  const handlePostClick = (postId: number) => {
    setPostIdClicked(postId);
    setShowPosts(true);
  };

  const perfilImageRef = useRef<HTMLInputElement | null>(null);

  const handleEditPerfilImage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (perfilImageRef.current) {
      perfilImageRef.current.click();
    }
  };

  const uploadUserImage = async () => {
    if (perfilImageRef.current && perfilImageRef.current.files) {
      const formData = new FormData();
      formData.append("image", perfilImageRef.current.files[0]);

      const response = await api.post("/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Define o tipo de conteúdo como multipart/form-data
        },
      });

      // Update user image
      editPerfil({ image: response.data.url });
    }
  };

  return (
    <>
      <Header />
      <Container>
        <PerfilStyled>
          <div className="perfil-card">
            {loading ? (
              <Loading $width="50px" />
            ) : (
              <>
                <div className="perfil-info">
                  <div className="info-user">
                    <button onClick={handleEditPerfilImage}>
                      {
                        user && user.id === userPage!.id &&
                        (<input
                          type="file"
                          ref={perfilImageRef}
                          onChange={uploadUserImage}
                          hidden
                        />)
                      }
                      <img id="user-img" src={userPage?.image} alt="" />
                    </button>

                    <div className="bio-user">
                      <div className="text">
                        <p>
                          {!!userPage &&
                            userPage?.name.charAt(0).toUpperCase() +
                            userPage?.name.slice(1)}
                        </p>
                        <span>
                          <img
                            id="user-icon"
                            src={userPage?.icon}
                            alt="user-icon"
                          />
                          {userPage?.username}
                        </span>
                      </div>
                      {/* MOSTRAR A EDIÇÃO SO PARA O DONO DO PERFIL */}
                      {user?.id === userPage?.id && (
                        <>
                          <div className="interact">
                            <abbr title="Editar perfil">
                              <RoundButton onClick={() => setShowEdit(true)}>
                                <FaPenToSquare size={18} color="white" />
                              </RoundButton>
                            </abbr>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="text">
                      <abbr title="Bio">
                        <p>{userPage?.bio}</p>
                      </abbr>
                    </div>
                  </div>
                  <div className="info-follow">
                    <div id="follower" onClick={() => setShowFollowers(true)}>
                      <span>Seguidores</span>
                      <p>{userPage?.Followers.count}</p>
                    </div>
                    <div id="following" onClick={() => setShowFollowing(true)}>
                      <span>Seguindo</span>
                      <p>{userPage?.Following.count}</p>
                    </div>
                    {showFollowers && (
                      <Follower
                        setShowFollowers={setShowFollowers}
                        userPage={userPage}
                      />
                    )}
                    {showFollowing && (
                      <Following
                        setShowFollowing={setShowFollowing}
                        userPage={userPage}
                      />
                    )}
                  </div>
                </div>
                <div className="perfil-img">
                  {postsUser?.raw.map((post) => {
                    return (
                      <div key={post.id} className="post">
                        <div className="post-content">
                          <button
                            key={post.Images[0]?.id}
                            onClick={() => handlePostClick(post.id)}
                          >
                            <img src={post.Images.length > 0 ?
                              post.Images[0].url :
                              // colocar uma imagem em um post que só é texto
                              "https://res.cloudinary.com/ddhbhbxcs/image/upload/v1723835479/xgrjqfz0gonmt5t26i4q.png"}
                              alt="" />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {hasMorePosts && userPage?.id && (
                  <abbr title="Carregar mais posts">
                    <ButtonStyled onClick={() => loadMorePosts(userPage.id)}>
                      <FaArrowDown color="var(--color-white-fixed)" />
                    </ButtonStyled>
                  </abbr>
                )}
                {loadingPost && <Loading $width="50px" />}
              </>
            )}
          </div>
          {showEdit && (
            <ModalEdit showEdit={showEdit} setShowEdit={setShowEdit} />
          )}
        </PerfilStyled>
      </Container>

      <ModalPosts
        posts={postsUser}
        showPosts={showPosts}
        setShowPosts={setShowPosts}
        postIdClicked={postIdClicked}
        page={page}
        setPage={setPage}
        hasMorePosts={hasMorePosts}
        setHasMorePosts={setHasMorePosts}
      />
    </>
  );
};
